$(document).ready(function () {
    let tableAdsRenderCount = 0;

    function logTableAds(message, payload = null) {
        if (payload === null) {
            console.log('[table_items_7_ads] ' + message);
            return;
        }
        console.log('[table_items_7_ads] ' + message, payload);
    }

    function watchGoogleAdsStatus(adNode) {
        if (!adNode || typeof MutationObserver === 'undefined') {
            return;
        }

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-adsbygoogle-status') {
                    logTableAds('google ads status changed', adNode.getAttribute('data-adsbygoogle-status'));
                }
            });
        });

        observer.observe(adNode, {
            attributes: true,
            attributeFilter: ['data-adsbygoogle-status']
        });
    }

    function renderGoogleAdsInTableWrapper(wrapperSelector) {
        const $wrapper = $(wrapperSelector);
        if ($wrapper.length === 0) {
            logTableAds('wrapper not found', wrapperSelector);
            return;
        }

        let $container = $wrapper.find('.table-ads-refresh-slot');
        if ($container.length === 0) {
            $container = $('<div class="table-ads-refresh-slot mb-2"></div>');
            $wrapper.prepend($container);
        }

        $container.empty();

        const ad = document.createElement('ins');
        ad.className = 'adsbygoogle';
        ad.style.display = 'block';
        ad.setAttribute('data-ad-client', 'ca-pub-9506883618846145');
        ad.setAttribute('data-ad-slot', '1908836517');
        ad.setAttribute('data-ad-format', 'auto');
        ad.setAttribute('data-full-width-responsive', 'true');
        $container.append(ad);
        watchGoogleAdsStatus(ad);

        try {
            tableAdsRenderCount += 1;
            logTableAds('adsbygoogle.push start', { renderCount: tableAdsRenderCount });
            (adsbygoogle = window.adsbygoogle || []).push({});
            logTableAds('adsbygoogle.push done', { renderCount: tableAdsRenderCount });
        } catch (e) {
            logTableAds('adsbygoogle.push error', e);
        }
    }

    function initTableAdsRefresh(tableSelector, wrapperSelector) {
        const $table = $(tableSelector);
        if ($table.length === 0) {
            return;
        }

        logTableAds('bind datatable ads refresh', { tableSelector: tableSelector, wrapperSelector: wrapperSelector });

        renderGoogleAdsInTableWrapper(wrapperSelector);

        $table.on('page.dt.adsRefresh', function () {
            logTableAds('datatable page event fired');
        });

        $table.on('search.dt.adsRefresh', function () {
            logTableAds('datatable search event fired');
        });

        $table.on('draw.dt.adsRefresh', function () {
            logTableAds('datatable draw event fired, refreshing ad');
            renderGoogleAdsInTableWrapper(wrapperSelector);
        });
    }

    $('#table_items').DataTable( {
        "responsive": true,
        "columns": [
            { "width": "5%", "targets": 0, "orderable": false },
            { "width": "20%" },
            null,
            null,
            null,
            null,
            { "width": "20%" },
        ]
    } );

    $('#table_items_4').DataTable( {
        "responsive": true,
        "columns": [
            { "width": "5%", "targets": 0, "orderable": false },
            { "width": "20%" },
            { "width": "10%" },
            { "width": "15%" },
        ]
    } );

    $('#table_items_5').DataTable( {
        "responsive": true,
        "columns": [
            { "width": "5%", "targets": 0, "orderable": false },
            { "width": "30%" },
            { "width": "25%" },
            { "width": "25%" },
            { "width": "15%" },
        ]
    } );

    $('#table_items_6').DataTable( {
        "responsive": true,
        "columns": [
            { "width": "5%", "targets": 0, "orderable": false },
            { "width": "20%" },
            { "width": "15%" },
            { "width": "20%" },
            { "width": "20%" },
            { "width": "5%" },
        ]
    } ).on('draw.dt', function () {
        reloadAd("#table_ads");
    });

    $('#table_items_7').DataTable( {
        "responsive": true,
        "columns": [
            { "width": "5%", "targets": 0, "orderable": false },
            { "width": "15%" },
            { "width": "15%" },
            { "width": "15%" },
            { "width": "15%" },
            { "width": "15%" },
            { "width": "5%" },
        ]
    });

    initTableAdsRefresh('#table_items_7', '#table_items_7_wrapper');

    function reloadAd(targetSelector) {
        var adHtml = `
        <ins class="adsbygoogle"
             style="display:block"
             data-ad-client="ca-pub-9506883618846145"
             data-ad-slot="1908836517"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
    `;
        $(targetSelector).html(adHtml);
        (adsbygoogle = window.adsbygoogle || []).push({});
    }


    $('#vin').on('input', function () {
        if ($(this).val().length === 17) {
            $.ajax({
                method: "POST",
                url: "/profile/cars/getVin",
                data: {vin: $(this).val(), "_token": $(this).data('token'),}
            })
                .done(function (msg) {
                    //console.log( "Data arrived: " + msg );
                    obj = JSON.parse(msg);

                    $('input#model').val(obj.model);

                    $("input#year option[value=2008]").attr('selected', 'true');
                    $('input#year').val(obj.year);
                    $('input#manufacturer').val(obj.manufacturer);

                });
        }
    })

    $('#vinModal').on('show.bs.modal', function (event) {
        const modal = $(this);
        modal.find('.modal-title').text('Ckecking VIN '+ $('#vin-fake').val());
        setTimeout(function(){
            location.href = '/services/vin-decoder/'+ $('#vin-fake').val();
            }, 3000);
    });


    $('#BCMContainer li div').click(function() {
        //console.log( 'Data-value = '+$(this).parent().data("value") );

        if ($(this).parent().data("value") === 0) {
            $(this).parent().data("value",1);
            $(this).css('background-color', '#fff');
        }
        else {
            $(this).parent().data("value", 0);
            $(this).css('background-color', '#444');
        }

        //console.log( $(this).parent().data('value') );
        $('#maskVal').html( calcMask() );

    });

    function calcMask() {
        let res = 0;
        let res_bin = '';

        for (let i=0; i<52; i++) {
            res_bin+=0;
        }

        $( "li" ).each(function( item ) {

            if( $( this ).data('value') === 1) {
                res_bin[ $( this ).data('id') ] = 1;
                console.log( item + ": " + $( this ).data('id') );
                res += Math.pow(2, $( this ).data('id'));
            }

        });

        return res + ' / ' + res_bin;
    }
})
